import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { WithAuditContext } from '../http-mutating-operations.interceptor';
import { SemantriaAPIService } from '../semantria-api.service';

export type ResponseType = 'POLLING' | 'AUTORESPONSE' | 'CALLBACK';

export interface ConfigurationRoute {
  route_id: string;
  name: string;
  notes?: string;
  response_type: ResponseType;
  callback_url: string;
  creation_date: Date;
  modification_date?: Date;
  last_use_date?: Date;
  account_id: string;
  configuration_map: { [key: string]: string };
  default_language_id?: string;
  translation_target_language_id?: string;
  isConfigurationRoute?: boolean;
}

@EnableClassTelemetry()
@Injectable()
export class ConfigurationRouteService extends SemantriaAPIService {
  getConfigurationRoutes(groupId: string): Promise<ConfigurationRoute[]> {
    const params = {
      group_id: groupId,
    };
    return this.get(`/routes/`, params);
  }

  getConfigurationRoute(id: string): Promise<ConfigurationRoute> {
    return this.get(`/routes/${id}`);
  }

  @WithAuditContext('configuration-route-created', (_, args) => {
    return { route_id: args[0].route_id, name: args[0].name, groupId: args[1] };
  })
  createConfigurationRoute(
    route: ConfigurationRoute,
    groupId: string
  ): Promise<ConfigurationRoute> {
    const urlparams = {
      group_id: groupId,
    };
    const body = this.transformRoute(route);

    return this.post(`/routes/`, body, {}, urlparams);
  }

  @WithAuditContext('configuration-route-updated', (_, args) => {
    return { route_id: args[0].route_id, name: args[0].name };
  })
  updateConfigurationRoute(route: ConfigurationRoute): Promise<ConfigurationRoute> {
    const body = this.transformRoute(route);

    return this.put(`/routes/${route.route_id}`, body);
  }

  private transformRoute(route: ConfigurationRoute) {
    const body = {
      ...route,
      configs: Object.values(route.configuration_map),
    };

    delete body.configuration_map;

    return body;
  }

  @WithAuditContext('configuration-route-deleted', (_, args) => {
    return { id: args[0] };
  })
  deleteConfigurationRoute(id: string): Promise<void> {
    return this.delete(`/routes/${id}`);
  }
}
